<script>
import Icon from './Icon.vue';

export default {
  components: {
    Icon,
  },

  props: {
    name: {
      type: String,
      default: '',
    },

    icon: {
      type: String,
      default: '',
    },

    isNavLink: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    dropdownClass() {
      if (this.isNavLink) {
        return 'nav-link dropdown-toggle d-none d-sm-inline-block';
      }
      return 'dropdown-item dropdown-toggle d-none d-sm-inline-block';
    },
  },
};
</script>

<template>
  <a :class="dropdownClass" href="#" data-bs-toggle="dropdown">
    {{ name }}
    <Icon v-if="icon !== undefined && name.length === 0" :class-name="icon" />
  </a>
</template>
